module.exports = __webpack_public_path__ + "static/media/remove-track.b8430f54.svg";